export default "__VITE_ASSET__BrzqGV1o__"